import { round } from "lodash";

/** How long the in-the-money table waits after the price field changes, so typing is not one request per key. */
export const ITM_TYPING_DEBOUNCE_MS = 1000;

/**
 * Delay before the in-the-money request for `itmPrice`. The field is filled in from the first live
 * tick (`firstPrice`, rounded to cents); while it still holds that value nobody is typing, so the
 * table loads at once. Any other value is an edit and waits out the debounce.
 */
export const itmFetchDelay = (itmPrice: string, firstPrice: number | undefined): number => (firstPrice !== undefined && itmPrice === round(firstPrice, 2).toString() ? 0 : ITM_TYPING_DEBOUNCE_MS);
